import styled from 'styled-components';
import { breakpoints } from '../../breakpoints';

export const body = styled.div`
display: flex ;
z-index: 1 ;
font-size: clamp(12px, 3vw, 16px);
border-radius:3px;
justify-content: center;

@media ${breakpoints.sm} {
  justify-content: center;
}

button{
  cursor: pointer;

}

.titulo{
  display: flex ;
  width:100% ;
  min-height:42px ;
  align-items: center ;
  position: relative ;
}
.tituloHover{
  color: white ;
  &:hover{
    color: yellow ;
  }

}
.tituloUser{
  display: flex;
  width:100% ;
  justify-content: center ;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.fechar{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  position: absolute ;
  right: 10% ;
  color:#f0433d;
  border-radius:50%;
  border: 1px solid #f0433d;
  padding:0;

  cursor: pointer;
  font-weight:bold;
  transition: all .2s ease;

  &:hover{
    color:white;
    background-color: #f0433d;
}}
select{
  background-color:#3881ff;
  color: ${props => props.editModal ? '#ffecaa' : 'white'};
}
label, span{
  color: ${props => props.editModal ? '#ffecaa' : '#00D594'};
}

.saldoCred{
    color:${props => props.saldo < 0 ? "red" : "black"} ;
    font-weight:600 ;
};
.saldoNovo{
    color:${props => props.saldoNovo < 0 ? "red" : "black"} ;
    font-weight:600 ;
};
`
//-----------------------------------------------
export const Container = styled.div`
display: flex;
flex-direction:column ;
width:100vw ;
max-width:500px ;
height: 85vh ;

@media ${breakpoints.sm} {
  width:90vw ;
}

.listaFlexCol{
  display: flex ;
  flex:1 ;
  flex-direction: column ;
  text-transform:capitalize;
  color: white ;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

input{
color: white ;
border:1px solid #3881ff;
outline:0;
background-color: #30353F ;
border-radius:8px;
padding: 0 10px;
transition: all .2s ease;
}

input, select{
  min-height:34px ;
}

select{
  display:flex;
  width: 100%;
  border-radius:8px;
  border:1px solid #3881ff;
  outline:0;
  padding: 0 10px;
  transition: all .2s ease;
}

input:focus,
select:focus,
textarea:focus{
  border-color: #00D594;
  box-shadow: 0 0 0 2px rgba(0, 213, 148, 0.2);
}

`
//-----------------------------------------------
export const ContainerBanco = styled.div` 
display:${props => props.playModalBanco ? 'flex' : 'none'};

`
// ------------------------------------------
export const div3 = styled.div` 
display:flex;
flex-direction: column ;
width:100%;
color: #00D594;
align-items: center ;
background-color: #262626;
padding-bottom: 10px ;

.spanBranco{
  margin:0px ;
  color: white ;
}

.novoCad{
  color: black ;
  background-color: white ;
  padding: 1px 3px ;
  cursor: pointer;
}

.maiusculo{
  text-transform:capitalize
}
.uppercase{
  text-transform:uppercase
};

.intemSelect{
  display: flex ;
  align-items: center ;
  height: 30px ;
  background-color: #30353F;
  color: white ;
  min-height: 25px ;
  cursor: pointer;
  padding-left: 5px ;
  text-transform:capitalize;
};
.intem{
  display: flex ;
  color: #d8e5ffff;
}

textarea{
  display: flex ;
  width:98% ;
  min-height: 70px ;
  background:none;
  border:1px solid #3881ff;
  border-radius:5px;
  outline:0;
  color: white ;
  margin: 5px 5px ;
}

.EditarSelect{
  display: flex ;
  flex:1 ;
  flex-direction: column ;
  margin: 0 5px ;
}
`
// ------------------------------------------
export const divPrevia = styled.div` 
display:flex;
flex-direction: column ;
width:100%;
align-items: center ;

@media ${breakpoints.sm} {
  width:90vw ;
}
`
// -----------------------------------
export const divPesq = styled.div`
display: flex ;
flex-direction: column ;
position: relative ;
width:98% ;
align-items: center ;

`
// -----------------------------------
export const divListaBD = styled.div`
display: flex ;
flex-direction: column ;
margin-top:5px ;
position: absolute ;
left: 120px ;
transform: translateX(-50%);
z-index: 10;

`
// -----------------------------------
export const divListaVistoria = styled.div`
display: flex ;
flex-direction: column ;
margin-top:5px ;
position: fixed ;
z-index: 1;

@media ${breakpoints.sm} {
  left:35px;
}

`

// -----------------------------
export const containerPesq = styled.div` 
display: flex;
flex-direction: column ;
align-items: center ;
`
// -----------------------------------
export const box = styled.div`
width:100%;
flex-direction:column;
border-bottom:1px solid #3881ff;
padding: 3px 0 ;

span{
  margin: 0 5px ;
}

.spa{
  color:white ;
}
.multiselect{
  color: black ;
  background-color: #3881ff;
}

`
// --------------------------------------------------------

export const boxCPF = styled.div` 
display:flex;
flex-wrap:wrap ;
border-bottom:1px solid #3881ff;
min-width: 300px ;
padding: 3px 0 ;

input{
  text-transform:capitalize;
}

@media ${breakpoints.sm} {
  flex-direction: column ;
}

div{
  display: flex ;
  flex:1 ;
  flex-direction:column ;
  margin: 0 5px ;
}

.spa{
  color:white ;
}

`
// ------------------------------------
export const boxFiles = styled.div`
display: flex ;
width:95% ;
max-height: 400px;
overflow-y:auto ;

`
// ------------------------------------
export const box1 = styled.div` 
display:flex;
width:98% ;
border-bottom:1px solid #3881ff;
gap: 5px;
position: relative ;
padding: 8px 0;

input{
  text-transform:capitalize;
}

div{
  display: flex;
  flex:1 ;
  flex-direction: column;
  gap: 4px;
}

span{
  margin: 0 2px;
}

@media ${breakpoints.sm} {
  flex-direction: column ;
}

button{
  display: flex ;
  background-color: white ;
  align-items: center ;
  justify-content: center ;
  color: black ;
  height: 18px ;
  margin: 2px 0;
  border: none ;
  border-radius: 3px ;
  cursor: pointer;

  &:hover{
    background-color:#00ff9d;
    }
}

`
// ------------------------------
export const box2 = styled.div`
display:flex;
width:100% ;
`
// --------------------------------
export const box3 = styled.div`
display:flex;
flex-wrap: wrap ;
width:100%;
gap: 5px;

@media ${breakpoints.sm} {
  flex-direction: column ;
}
`
// -------------------------------
export const lista = styled.div` 
flex-direction: column ;

button{
  display: flex ;
  background-color: white ;
  align-items: center ;
  color: black ;
  width: 140px ;
  height: 20px ;
  margin: 2px 0;
  border: none ;
  cursor: pointer;
}
`
// ---------------------------------
export const bodyresult = styled.div`
display: flex ;
width:95% ;
align-items: start ;
`
// -----------------------------------
export const pag = styled.div`
width:100%;
margin:5px;
border-bottom:1px solid #3881ff;

div{
  display:flex;
}

span{
  display:flex;
  margin-right:10px;
}
`
//-----------------------------
export const divButton = styled.div` 
display: flex ;
justify-content: center ;
margin-top: 10px ;

button{
  background-color:#00D594;
  min-width: 110px;
  min-height:34px;
  margin:3px;
  justify-content:center;
  border:none;
  border-radius:8px;
  color:${props => props.editModal ? 'white' : 'black'};
  cursor: pointer;
  font-weight: 600;
  transition: all .2s ease;

  &:hover{
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

}
`

export const PagamentoOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.55);
`;

export const PagamentoCard = styled.div`
  display: flex;
  flex-direction: column;
  width: min(540px, 100%);
  max-height: 90vh;
  overflow: hidden;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.25);
`;

export const PagamentoHeader = styled.div`
  display: flex;
  justify-content: space-between ;
  flex-shrink: 0;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  color: #111827;
  font-weight: 700;

  button {
    flex-shrink: 0;
    border: 0;
    background: transparent;
    color: #6b7280;
    font-size: 1.3rem;
    line-height: 1;
    cursor: pointer;
  }
`;

export const PagamentoBody = styled.div`
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 20px;

  .lista {
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 0;
    margin-bottom: 16px;
  }

  .titulo {
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
  }

  .linhaCampos {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
  }

  input,
  select {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 10px 12px;
    background: #f9fafb;
    color: #111827;
    font-size: 0.9rem;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

    &:hover {
      border-color: #9ca3af;
    }

    &:focus {
      border-color: #2d6cdf;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(45, 108, 223, 0.14);
      outline: 0;
    }
  }

  @media (max-width: 768px) {
    padding: 16px;
  }

  @media (max-width: 520px) {
    .linhaCampos {
      grid-template-columns: 1fr 1fr;
    }

    .linhaCampos .lista:first-child {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 360px) {
    .linhaCampos {
      grid-template-columns: 1fr;
    }

    .linhaCampos .lista:first-child {
      grid-column: auto;
    }
  }
`;

export const PagamentoFooter = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e5e7eb;

  button {
    border: 0;
    border-radius: 6px;
    padding: 9px 16px;
    font-size: 0.85rem;
    font-weight: 700;
    cursor: pointer;
  }

  button:first-child {
    background: #f3f4f6;
    color: #374151;
  }

  button:last-child {
    background: #2d6cdf;
    color: #fff;

    &:disabled {
      background: #93c5fd;
      cursor: not-allowed;
    }
  }

  @media (max-width: 768px) {
    padding: 12px 14px;

    button {
      padding: 9px 12px;
    }
  }
`;

// ------------------------------
export const Modal = styled.div`
display: flex ;
overflow:auto ;
flex-direction: column ;

button{
  background-color:#00D594;
  min-width: 110px;
  min-height:34px;
  margin:3px;
  justify-content:center;
  border:none;
  border-radius:8px;
  color:${props => props.editModal ? 'white' : 'black'};
  cursor: pointer;
  font-weight: 600;
  transition: all .2s ease;

  &:hover{
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

}
`

// --------------------------------------------------------
export const Salvar = styled.div`

`
// --------------------------------------------------------
export const Atualizar = styled.div`

`
//--------------Banco----------------------------------

export const addBanco = styled.div` 
display:${props => props.aletBanco ? 'flex' : 'none'};
position: fixed ;
top: 200px ;
font-weight:600;


.addbanco{
  display: flex ;
  flex-direction: column ;
  width: 150px ;
  height: 50px ;
  background-color: white ;
  border-radius: 2px;
  box-shadow: 0px 0px 50px black;
  justify-content: center ;
  padding: 10px ;

}
label{
  display: flex ;
  text-align: center ;
}
button{
  display: flex ;
  width: 50px ;
  border-radius: 2px;
  padding-top: 3px ;
  cursor:pointer ;
  border:none ;
  justify-content: center ;
  font-weight:700;
  background-color:#e2ecff
}
.simnao{
  display: flex ;
  width:100% ;
  justify-content: end ;
  margin-top: 7px;
  color: white ;

}
.nao{
  color:#f0433d ;
  &:hover{
  background-color:#f0433d;
  color: white ;
}
}
.sim{
  color:#3881ff ;
  margin-left: 10px ;
  &:hover{
  background-color:#16b992;
  color: white ;
}
}
`

// #############################################################################

export const ModalAviso = styled.div`
 display:flex;
 width:95% ;
 max-width: 400px ;
 position: fixed;
 z-index: 1 ;
 flex-direction: column ;
 background-color:#ff8e8e ;
 color:black ;
 justify-content: center ;
 align-items: center ;
 padding: 10px 0 ;

`
//-------------------------------
